import { CircularProgress } from "@material-ui/core";
import { Delete, Menu } from "@material-ui/icons";
import { useState } from "react";
import { BooleanInput, Button, Datagrid, Edit, EmailField, FormDataConsumer, FormTab, Pagination, ReferenceInput, ReferenceManyField, SelectInput, TabbedForm, TextField, TextInput, useRedirect, useRefresh } from "react-admin";
import { Spacer } from "../../components/spacer";
import UserImportButton from "../../components/user-import-button/user-import-button";
import dataProvider from "../../providers/data-provider";
import ClassEditAddStudent from "./class-edit-add-student";

const ClassEdit = (props) => {


    const [loading, setLoading] = useState(false)

    const refresh = useRefresh()
    const redirect = useRedirect()

    const handleRemoveStudent = async (classId, userId) => {
        setLoading(true)
        await dataProvider.delete(`classes/${classId}/student`, { id: userId })

            .finally(() => {
                setTimeout(() => {
                    setLoading(false);
                    refresh();
                }, 2000)
            });
    }


    return (
        <Edit
            mutationMode="pessimistic"
            actions={
                <div style={{ display: 'flex', marginBottom: '16px' }}>
                    <Button variant="contained" label="Retornar" startIcon={<Menu />} onClick={() => redirect('/classes')} />
                    <Spacer />
                    <UserImportButton label={'Importar alunos para turma'} importToClass={props.id} /></div>
            }
            {...props}
        >
            <TabbedForm>
                <FormTab label={'Dados Gerais'}>
                    <TextInput source="name" label={'Nome'} fullWidth />
                    <TextInput source="description" label={'Descrição'} fullWidth />
                    <ReferenceInput label="Período letivo" source="academic_period.id" reference="academic-periods" fullWidth>
                        <SelectInput optionText={'name'} optionValue={'id'} />
                    </ReferenceInput>
                    <BooleanInput label={"Turma com acesso ao Juristta Office?"} source="has_office_access" fullWidth />
                </FormTab>
                <FormTab label={'Alunos'}>
                    <ReferenceManyField pagination={<Pagination />} fullWidth reference="user-contexts" target='classId' sort={{ field: 'user.name', order: 'ASC' }} label={'Alunos'}>
                        <Datagrid>
                            <TextField source='user.name' label={'Nome'} fullWidth />
                            <EmailField source='user.email' label={'Email'} fullWidth />
                            <FormDataConsumer>
                                {({ formData, record, ...rest }) => (
                                    <Button label="Remover"
                                        onClick={() => handleRemoveStudent(formData.id, record.id)}
                                        startIcon={loading ? <CircularProgress size={16} /> : <Delete />}
                                        disabled={loading}
                                    />
                                )}
                            </FormDataConsumer>
                        </Datagrid>
                    </ReferenceManyField>
                    <FormDataConsumer>
                        {({ formData, record, ...rest }) => (
                            <ClassEditAddStudent
                                record={record}
                                resource={'classes'}
                                path={'user'}
                                title={`Adicionar alunos à turma ${record.name}`}
                                refresh={refresh}
                            />
                        )}
                    </FormDataConsumer>
                </FormTab>
            </TabbedForm>
        </Edit >
    )
}

export default ClassEdit;